export const LabelText = {
  FIRST_NAME: 'First name*',
  LAST_NAME: 'Last name*',
  EMAIL: 'Email*',
  PHONE_REQUIRED: 'Phone Number*',
  PHONE_OPTIONAL: 'Phone Number',
  DEPARTMENT: 'Department*',
  EMPLOYEE_ID: 'Employee ID',
  EXPENSE_CODES: 'Expense Codes',
  COST_CENTER: 'Cost Center',
  DRAWER_TITLE_BASIC_INFORMATION: 'Basic Information',
  DRAWER_TITLE_EXPENSE: 'Expense',
  CHECKBOX_LABEL_EXPENSE: 'Eligible to all expense codes'
};

export const TestId = {
  phone: 'phone-input'
};
